import { useParams } from "react-router";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loader from "../Common/Loader";
import { SitePage } from "../../Models/SitePage";
import SitePageApi from "../../Api/SitePageApi";
import FormFillerWrapperByPage from "../Forms/FormFillerWrapperByPage";

export default function CustomSitePage() {
  const { id } = useParams();
  //   const { userModel } = useAppSelector((state) => state.user);
  const [pageData, setPageData] = useState<SitePage>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    //   getSitePages();
    getSitePage();
  }, [id]);

  const getSitePage = () => {
    if (id) {
      setIsLoading(true);
      SitePageApi.getSitePage(id)
        .then((res) => {
          const data = res.data;
          setPageData(data);
          setIsLoading(false);
        })
        .catch((err) => {
          console.error(err);
          setIsLoading(false); // <-- important!
        });
    }
  };

  return (
    <>
      <title>{pageData?.title}</title>
      <div className="w-full">
        <div className="w-full p-4">
          <div className="mx-1 flex items-center justify-center flex-col gap-1 text-center">
            <h5 className="text-gray-900 font-bold text-4xl">
              {pageData?.header}
            </h5>
            {pageData?.memberId && (
              <Link
                to={`/member/${pageData.memberId}`}
                className="text-green-700 hover:underline text-lg font-medium"
              >
                {"(View Member Profile)"}
              </Link>
            )}
          </div>
        </div>
        <div className="p-5">
          {isLoading && <Loader />}
          <div
            dangerouslySetInnerHTML={{
              __html: pageData?.description ?? "",
            }}
          />
          {pageData?.enbedCode && (
            <center>
              <iframe
                src={pageData?.enbedCode}
                width={pageData?.iframeWidth ? pageData.iframeWidth : "650"}
                height={pageData?.iframeHeight ? pageData.iframeHeight : "4500"}
                style={{ border: "none" }}
              ></iframe>
            </center>
          )}
          <div className="w-full p-4">
            <FormFillerWrapperByPage pageId={id!} />
          </div>
        </div>
      </div>
    </>
  );
}
